<template>
  <p class="tm-faq-parapragh">
    <slot
      v-if="withIcon"
      name="icon"
    >
      <tm-icon
        name="tmi-task-circle"
        color="green"
        size="xLarge"
      />
    </slot>

    <b v-if="title">{{ title }}</b>

    <span v-if="text">{{ text }}</span>
  </p>
</template>

<script setup lang="ts">
import TmIcon from '@/components/shared/TmIcon.vue'

defineProps<{
  withIcon?: boolean
  title?: string
  text?: string
}>()
</script>

<style lang="scss" scoped>
.tm-faq-parapragh {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
